import { Outlet } from 'react-router';
import { useBreadcrumb } from '~/components/layout/Breadcrumb';

export default function UploadVomWrapperRoute() {
  useBreadcrumb('routes/upload/vom', 'Virtual Outcrop Models');
  return <Outlet />;
}
